import { DiagramComponentInstance, DiagramConnection } from 'models';

import faultSimSnippet from './fault-sim-tour-snippet.json';
import wireSizingSnippet from './wire-sizing-tour-snippet.json';

export const FAULT_SIM_TOUR_SNIPPET_NAME = 'Fault simulation example';
export const FAULT_SIM_CONNECTION_ID = 'connection-fault-sim';

export const WIRE_SIZING_TOUR_SNIPPET_NAME = 'Wire sizing example';
export const WIRE_SIZING_CONNECTION_ID = 'connection-converter-1-bus';

type RawTourSnippet = {
    componentInstances: unknown[];
    connections: unknown[];
};

const toRecord = <T extends { id: string }>(items: T[]): Record<string, T> =>
    items.reduce<Record<string, T>>((accumulator, item) => {
        accumulator[item.id] = item;

        return accumulator;
    }, {});

const buildTourSnippet = (snippet: RawTourSnippet) => ({
    componentInstances: toRecord(snippet.componentInstances as unknown as DiagramComponentInstance[]),
    connections: toRecord(snippet.connections as unknown as DiagramConnection[]),
});

export const FAULT_SIM_TOUR_SNIPPET = buildTourSnippet(faultSimSnippet as RawTourSnippet);

export const WIRE_SIZING_TOUR_SNIPPET = buildTourSnippet(wireSizingSnippet as RawTourSnippet);
